"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsRecipeParameterValueTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsExport = require("../DmsExport/DmsExport");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsRecipeTable.
 * Renders a DmsTable with recipe parameter value datas
 * @component
 * @example
 * return (
 *   <DmsRecipeParameterValueTable />
 * )
 */

const DmsRecipeParameterValueTable = _ref => {
  let {
    row_pk = null
  } = _ref;
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("RecipeParameter").d("Recipe parameter"),
    column_name: "recipe_parameter",
    form_column_name: "recipe_parameter_pk",
    function: recipe_parameter => (recipe_parameter || {}).name,
    control: 'select',
    url: "/recipe_parameter/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: 'name',
      filter: {
        value: "pk",
        field: "recipe_parameter_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Recipe").d("Recipe"),
    column_name: "recipe",
    form_column_name: "recipe_pk",
    function: recipe => (recipe || {}).name,
    control: 'select',
    url: "/recipe/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: 'name',
      filter: {
        value: "pk",
        field: "recipe_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Value").d("Value"),
    column_name: "value",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "5vw",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateRecipeParameterValue", {
          name
        }).d("Update recipe parameter ".concat(name)),
        url: "/recipe_parameter_value",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteRecipeParameterValue", {
          name
        }).d("Delete recipe parameter value ".concat(name)),
        text: _reactIntlUniversal.default.get("RecipeParameterValue.DeleteMensage", {
          name
        }).d("Delete recipe parameter value with name ".concat(name, ". Are you sure about it?")),
        url: "/recipe_parameter_value",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateRecipeParameterValue").d("Create recipe parameter value"),
    url: "/recipe_parameter_value",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "recipe_parameter_value/table",
    pre_filter: row_pk ? [{
      name: "recipe_pk",
      value: row_pk
    }] : null,
    responsive: true,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsRecipeParameterValueTable = DmsRecipeParameterValueTable;